import React, { useEffect, useState } from "react";
import s from "../Comprobantes.module.css";

//assets
import gamesService from "../../../../api/games/GamesService";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//Material Ui
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Button,
  Select,
  TextField,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/es";
import "dayjs/locale/pt";

const FiltrosComprobantes = ({
  searching,
  handleSearch,
  handleCleanFilters,
  dateType,
  setDateType,
  filters,
  setFilters,
  setLoadingFilters,
  games,
  setGames,
  setSort,
}) => {
  const { t } = useTranslation();
  const organization = useSelector((state) => state.gamma.activeOrganization);
  const { language } = useSelector((state) => state.local);

  useEffect(() => {
    if (!games.length) {
      setLoadingFilters(true);
      gamesService.getAllGames().then((res) => {
        setGames(res.content);
        setLoadingFilters(false);
      });
    }
  }, []);

  return (
    <Grid item container xs={11} className={s.filters}>
      <Grid item xs={11} md={5} lg={3} className={[s.item, s.init1]}>
        <FormControl sx={{ width: "90%" }}>
          <InputLabel
            id={"select-label"}
          >{`${t("type")} de ${t("game")}`}</InputLabel>
          <Select
            labelId="select-label"
            label={`${t("type")} de ${t("game")}`}
            value={filters.gameType}
            onChange={(e) => {
              setFilters((prev) => ({
                ...prev,
                gameType: e.target.value,
                gameId: 0,
              }));
            }}
          >
            <MenuItem value={0}>{t("select")}</MenuItem>
            <MenuItem value={1}>{t("preprinted")}</MenuItem>
            <MenuItem value={2}>{t("instant")}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {!filters.gameType ? null : (
        <>
          <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
            <FormControl sx={{ width: "90%" }}>
              <InputLabel id={"select-label-game"}>{t("game")}</InputLabel>
              <Select
                labelId="select-label-game"
                label={t("game")}
                disabled={!filters.gameType}
                value={filters.gameId}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, gameId: e.target.value }))
                }
              >
                <MenuItem value={0}>{t("all")}</MenuItem>
                {games?.map((item, i) => {
                  return item.modality.mode.id === filters.gameType ? (
                    <MenuItem key={i} value={item.modality?.game?.id}>
                      {item.modality?.game?.name}
                    </MenuItem>
                  ) : null;
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={11} md={5} lg={3} className={[s.item, s.init3]}>
            <TextField
              value={filters.agencyNumberFrom}
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  setFilters((prev) => ({
                    ...prev,
                    agencyNumberFrom: Number(e.target.value),
                  }));
                }
              }}
              label={`${t("agency")} ${t("from")}`}
              sx={{ width: "90%" }}
            />
          </Grid>

          <Grid item xs={11} md={5} lg={3} className={[s.item, s.init3]}>
            <TextField
              value={filters.agencyNumberTo}
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  setFilters((prev) => ({
                    ...prev,
                    agencyNumberTo: Number(e.target.value),
                  }));
                }
              }}
              label={`${t("agency")} ${t("to")}`}
              sx={{ width: "90%" }}
            />
          </Grid>

          <Grid item xs={11} md={5} lg={3} className={[s.item, s.init2]}>
            <FormControl sx={{ width: "90%" }}>
              <InputLabel
                id={"select-label"}
              >{`${t("type")} de ${t("date")}`}</InputLabel>
              <Select
                labelId="select-label"
                label={`${t("type")} de ${t("date")}`}
                value={dateType}
                onChange={(e) => {
                  if (e.target.value === 0) {
                    setDateType(e.target.value);
                    setFilters((prev) => ({
                      ...prev,
                      date: null,
                    }));
                  } else {
                    setDateType(e.target.value);
                  }
                }}
              >
                <MenuItem value={0}>{t("select")}</MenuItem>
                <MenuItem value={1}>{t("uploadDate")}</MenuItem>
                <MenuItem value={2}>{t("drawDate")}</MenuItem>
                <MenuItem value={3}>{t("expirationDate")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {!dateType ? null : (
            <>
              <Grid item xs={11} md={5} lg={3} className={[s.item, s.init1]}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={language}
                >
                  <DatePicker
                    label={!!filters?.date ? `${t("date")} X` : t("date")}
                    onChange={(e) =>
                      setFilters((prev) => ({ ...prev, date: e }))
                    }
                    inputFormat="DD/MM/YYYY"
                    clearable
                    value={filters.date || null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        sx={{ width: "90%" }}
                        InputLabelProps={{
                          onClick: () =>
                            setFilters((prev) => ({ ...prev, date: null })),
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
            </>
          )}
        </>
      )}
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Button
          disabled={!filters.gameType}
          onClick={handleSearch}
          variant="contained"
        >
          {t("consult")}
        </Button>
        {searching ? (
          <Button
            onClick={handleCleanFilters}
            variant="contained"
            sx={{ ml: 1 }}
          >
            {t("clearFilters")}
          </Button>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default FiltrosComprobantes;
